// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ob_5JkFVE","label":"ob_Xv4fWn"};